module.exports = __webpack_public_path__ + "../resources/img/ci_img1.df4f9dbc.png";